import { createAction } from 'typesafe-actions';
import type { SubscriptionInformation, AccountInformation } from './types';

export const logOut = createAction('user/LOG_OUT');

export const setAsAuthenticated = createAction('user/SET_AS_AUTHENTICATED');

export const setSubscriptionInformation = createAction(
    'user/SET_SUBSCRIPTION_INFORMATION',
    (wrapPayload) => (subscriptionInformation: SubscriptionInformation) => wrapPayload(subscriptionInformation),
);

export const setAccountInformation = createAction(
    'user/SET_ACCOUNT_INFORMATION',
    (wrapPayload) => (accountInformation: AccountInformation) => wrapPayload(accountInformation),
);
